import React from 'react';
import { UsersIcon } from '@heroicons/react/24/outline';
import useRouter from '../../hooks/useRouter';
import Urls from '../project-create/Urls';
import DataCard from '../profile-edit/DataCard';
import usePageRouter from '../../dialogs-routable/_hooks/usePageRouter';

export default function StudentSize(props) {
  const { project } = props;
  const { history } = usePageRouter();

  return (
    <DataCard
      title="Student group size"
      icon={UsersIcon}
      subtitle={project.data.groupSize || '(not provided)'}
      onClick={() => history.push(Urls(project).STUDENT_SIZE)}
    />
  );
};
